export default __webpack_public_path__ + "static/media/manab.7f78a23f.svg";